import React from "react";

export function ShopPageTitle({title, className}) {
    return <div className={`fs-2 fw-bolder mb-2 ${className}`}>{title}</div>
}